import { put, all, call, delay } from 'redux-saga/effects';
import { actionCreators as layoutActionCreators } from '../reducers/Layout';

/* tslint:disable */
export const apiCall = function* (action: string, callFn: Function, ...rest: any[]): unknown {
    yield put(layoutActionCreators.waitIniitalLoadState());
    yield put(layoutActionCreators.setLoading(action));
    const [result] = yield all([call(callFn as any, ...rest), delay(200)]);
    return result;
};



// WEBPACK FOOTER //
// ./src/reducers/SagaUtil.ts